import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import brand from '../../assets/img/brand/brand-square.jpg';
import './MainHeader.css';

const bgColors = {
  mpp: '#065fff',
  mxi: '#FF7FDE',
  mpg: '#45C945',
};

const MainHeader = ({signOut, user}) => {
  const pathname = window?.location?.pathname;

  const path = getPath(pathname);

  const color = bgColors?.[path];

  return (
    <header className="main-header">
      <Link to="/daily-report" className="logo">
        Admin<b className="text-uppercase">MPG</b>
      </Link>
      <nav
        className="navbar navbar-static-top"
        style={{
          backgroundColor: color,
          flexDirection: 'row',
          display: 'flex',
          opacity: 1,
          justifyContent: 'space-between',
        }}>
        <div>
          <a className="sidebar-toggle" data-toggle="push-menu" role="button">
            <span className="sr-only">Toggle navigation</span>
          </a>
          <ul className="apps-menu-container">
            <Link
              to="/user-support"
              className={
                path !== 'mpg'
                  ? 'apps-menu-item'
                  : 'apps-menu-item apps-menu-selected'
              }>
              MPG
            </Link>
            <Link
              to="/mpp/support"
              className={
                path !== 'mpp'
                  ? 'apps-menu-item'
                  : 'apps-menu-item apps-menu-selected'
              }>
              MPP
            </Link>
            <Link
              to="/mxi/players"
              className={
                path !== 'mxi'
                  ? 'apps-menu-item'
                  : 'apps-menu-item apps-menu-selected'
              }>
              FL1
            </Link>
          </ul>
        </div>

        <div
          className="navbar-custom-menu"
          style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
          <ul className="nav navbar-nav">
            <li className="dropdown user user-menu">
              <a className="dropdown-toggle" data-toggle="dropdown">
                <img
                  src={user.avatarUrl || brand}
                  className="user-image"
                  alt="User"
                />
                <span className="hidden-xs">
                  {user.name || 'Chèvre inconnue'}
                </span>
              </a>
              <ul className="dropdown-menu">
                <li className="user-header">
                  <img
                    src={user.avatarUrl || brand}
                    className="img-circle"
                    alt="User"
                  />
                  <p>{user.name || 'Chèvre inconnue'}</p>
                </li>
                <li className="user-body">
                  <div className="pull-right">
                    <a onClick={signOut} className="btn btn-default btn-flat">
                      <i className="fa fa-sign-out" /> Sign out
                    </a>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

MainHeader.propTypes = {
  signOut: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default MainHeader;

export const getPath = path => {
  if (path?.includes('mpp')) {
    return 'mpp';
  } else if (path?.includes('mxi')) {
    return 'mxi';
  }
  return 'mpg';
};



// WEBPACK FOOTER //
// ./src/components/MainHeader/index.js